import React from 'react'
import {Link} from 'react-router-dom'
import {Vector} from '../base/Elements'
import {getEnvironment} from '../../'


export const LinkButton = () => (
    <div></div>
)

export const LinkToRoot = () => (
    <div className='auth__backToForm'>
        <Link to='/' className='auth__backToForm-link'>
            До створення особистого кабінету
        </Link>
    </div>
)

export const LinkToPortal = () => (
    <div className='back-link__wrapper'>
        <a className='back-link__link' href={getEnvironment('PORTAL_URL')}>
            <Vector className='back-link__img' src='home' alt='' />
            На головну портала послуг
        </a>
    </div>
)
